import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import OrderInquiryBasicInfo from '../orders/order_inquiry_basic_info';
import ReactGA from "react-ga4"

class SchedulingRequest extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        let input = (props.location.state && props.location.state.data) ? props.location.state.data : {};
        input['RequestedTime'] = 'morning (7:30am-12noon)';
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            input: input,
            errors: {}
        };

        /*this.createSelectItems = this.createSelectItems.bind(this);*/
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        /*axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username
            }
        }).then(response => {
            if (response.data) {

                this.setState(() => ({
                    accounts: response.data
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });*/
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!this.state.userExists) {


            if (!input["firstName"]) {
                isValid = false;
                errors["firstName"] = "Please enter your first name.";
            }
            if (!input["lastName"]) {
                isValid = false;
                errors["lastName"] = "Please enter your last name.";
            }


            if (!input["phone"] || !String(input["phone"])
                .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
                isValid = false;
                errors["phone"] = "Invalid phone number.";
            }

            if (!input["email"] || !String(input["email"])
                .toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )) {
                isValid = false;
                errors["email"] = "Invalid email address.";
            }
        }

        if (!input["RequestedDate"]) {
            isValid = false;
            errors["RequestedDate"] = "Invalid.";
        }

        if (!input["RequestDetails"]) {
            isValid = false;
            errors["RequestDetails"] = "Invalid.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }
        this.setState({ loading: true });

        console.log(this.state);
        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        console.log(formData);
        for (var key in this.state.user) {
            formData.append(key, this.state.user[key]);
        }

        console.log(formData);

        axios.post(`${Constants.apiURL}/api/Request/scheduling`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'Scheduling',
                    label: 'Scheduling Request'
                });
                alert('Your scheduling request has been received. A member of our team will be in touch soon!');
                if (this.state.userExists) {
                    this.props.history.push({
                        pathname: '/orders',
                        state: {
                            user: this.state.user
                        }
                    });
                }
                else {
                    this.props.history.goBack();
                }
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });

    }

    render() {
        return (
            <div>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='schedulingRequest' /> : <GuestSiteMenu currentPage='schedulingRequest' />)}
                <Form.Label style={{ margin: 3, marginLeft: 10 }} className="form-header">SCHEDULING REQUEST</Form.Label>
                <br />
                <Form.Label style={{ margin: 3, marginTop: 0, marginLeft: 10, fontSize: '14px' }}>
                    Please provide requested date, time, and details below. If your scheduling request cannot be fulfilled, a member of our team will reach out to discuss alternative options.
                </Form.Label>
                <OrderInquiryBasicInfo style={{ margin: 5, marginTop: 10 }} data={this.state.input} />
                <Form onSubmit={this.handleSubmit} noValidate>
                    <div hidden={this.state.userExists}>
                        <Row style={{ margin: 5 }} >
                        <Col md>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={2} >First name</Form.Label>
                                <Col md={10}>
                                    <Form.Control type="input" name="firstName" value={this.state.input.firstName} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.firstName} />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={2} >Last name</Form.Label>
                                <Col md={10}>
                                    <Form.Control type="input" name="lastName" value={this.state.input.lastName} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.lastName} />
                                </Col>
                            </Form.Group>
                        </Col>
                        </Row>
                        <Row style={{ margin: 5 }} >
                            <Col md>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={2} >Email address</Form.Label>
                                    <Col md={10}>
                                        <Form.Control type="email" name="email" value={this.state.input.email} onChange={this.handleFormChange}
                                            isInvalid={!!this.state.errors.email} />
                                        <Form.Control.Feedback type='invalid'>
                                            {this.state.errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={2} >Phone number</Form.Label>
                                    <Col md={10}>
                                        <Form.Control type="phone" name="phone" value={this.state.input.phone} onChange={this.handleFormChange}
                                            isInvalid={!!this.state.errors.phone} />
                                        <Form.Control.Feedback type='invalid'>
                                            {this.state.errors.phone}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                    </Row>
                </div>
                    <Row style={{ margin: 5 }} >
                        <Col md={6}>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={2} >Requested Date</Form.Label>
                                <Col md={10}>
                                    <Form.Control type="date" min={moment().format('yyyy-MM-DD')} name="RequestedDate" value={this.state.input.RequestedDate} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.RequestedDate} />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={2} >Requested Time</Form.Label>
                                <Col md={10}>
                                    <Form.Select name="RequestedTime" value={this.state.input.RequestedTime} onChange={this.handleFormChange}>
                                        <option value="morning (7:30am-12noon)">morning (7:30am-12noon)</option>
                                        <option value="afternoon (12noon-5pm)">afternoon (12noon-5pm)</option>
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row style={{ margin: 5 }} >
                        <Col md={6}>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={2} >Request Details</Form.Label>
                                <Col md={10}>
                                    <Form.Control as="textarea" rows={3} name="RequestDetails" value={this.state.input.RequestDetails} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.RequestDetails} />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
                <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleSubmit}>
                    Submit
                </Button>
            </div>
        );
    }
}

export default SchedulingRequest;